import * as actionTypes from './actionTypes';
import { I_Itineraries } from './interfaces';

const initialState = {
    Features: '',
    BankContent: '',
    UpDateTime: '',
    Remark: '',
    TDHDesc: '',
    FeatureSrc: '',
    DailyList: [],
    EachTripList: [],
    OptionalInfoList: [],
    NoteList: [],
    LeaveTeamReg: '',
    SafeReg: '',
    ActiveNote: '',
    ItinnotesReg: '',
    lightBoxVisible: false,
    Name: '',
    ImgList: '',
    ImgMList: '',
    Introduction: '',
    Longtitude: 0,
    Latitude: 0,
    Address: '',
    PhoneList: [],
    WebUrl: '',
    Grade: [],
    CheckIn: '',
    CheckOut: '',
    StationInfoList: [],
    MarketingContent: {
        ImgPC: '',
        ImgM: '',
        Content: '',
        Url: '',
    },
};

const itinerariesReducer = (state: I_Itineraries = initialState, action: any): I_Itineraries => {
    const newState = { ...state };

    switch (action.type) {
        case actionTypes.SET_ITINERARIES_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_OPTIONALINFO_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_NOTICEINFO_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_POI_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.TOGGLE_LIGHT_BOX:
            newState.lightBoxVisible = !newState.lightBoxVisible;
            return newState;
        case actionTypes.SET_STATIONINFO_SUCCESS:
            return { ...state, ...action.payload };
        default:
            return newState;
    }
};

export default itinerariesReducer;
